import script from "./ZhimaSeriesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ZhimaSeriesCard.vue?vue&type=script&setup=true&lang=js"

import "./ZhimaSeriesCard.vue?vue&type=style&index=0&id=610b00b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-610b00b9"]])

export default __exports__